import { Injectable } from '@angular/core';
import { Order } from '@ct-client';
import { orderStatus } from '../../order/order-list/utils/order-list.status';

@Injectable({
    providedIn: 'root'
})
export class TopbarOrderService {

    private order: Order = null;

    public setOrder(order: Order) {
        this.order = order;
    }

    public getOrder() {
        return this.order;
    }

    public parseOrderStatus(status: string) {
        const finalStatus = orderStatus.find(s => s.id === status);
        return finalStatus ? finalStatus.name : '';
    }

    public parseOrderStatusColor(status: string) {
        const finalStatus = orderStatus.find(s => s.id === status);
        return finalStatus ? finalStatus.statusColor : '#000';
    }

}
